import { EmptyState } from '@/design'

/** Why the list is empty: the page's own filters, the filter bar's scope, or no competitions at all. */
export function NoRows({ filtered, scoped, onClear }: { filtered: boolean; scoped: boolean; onClear: () => void }) {
  if (filtered) {
    return (
      <EmptyState
        variant="no-results"
        compact
        title="No competitions match these filters"
        description="Try another status or category, or clear them."
        action={
          <button type="button" className="ci-button" onClick={onClear}>
            Clear filters
          </button>
        }
      />
    )
  }
  if (scoped) {
    return (
      <EmptyState
        variant="no-results"
        compact
        title="No competitions in this scope"
        description="No competition belongs to the website or environments chosen in the filter bar. Try another."
      />
    )
  }
  return (
    <EmptyState
      variant="no-data"
      compact
      title="No competitions yet"
      description="Competitions appear here once your website's competitions are syncing."
    />
  )
}
